import React from 'react'
import classnames from 'classnames'
import s from './AutoPromoGE.less'
import { withFrenchSite } from '../i18n/i18nSite'
import { withOnlyGE } from '../Device'
import AutoPromoOpenButton from './AutoPromoOpenButton'
import { SIZE_BIG } from '../genericComponents/buttons/RectangleActionButton'
import analyticsConstants from '../analytics/analytics.constants'
import devicePng from './assets/device.png'
import deviceWebp from './assets/device.webp'

const AutoPromoGE = ({ className }) => {
  return (
    <div className={classnames(className)}>
      <div className={s.content}>
        <picture>
          <source type="image/webp" srcSet={deviceWebp} />
          <img className={s.device} src={devicePng} width="102" height="142" />
        </picture>
        <div>
          <div className={s.title}>{'Tout Mappy dans votre poche'}</div>
          <p className={s.text}>{'Un GPS efficace et gratuit, trafic en temps réel et alertes de vitesse'}</p>
          <div className={s.infos}>
            <AutoPromoOpenButton size={SIZE_BIG} area={analyticsConstants.autopromo.area.main} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default withOnlyGE(withFrenchSite(AutoPromoGE))
